import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

const store = new Vuex.Store({
    pageHasLoaded: false,
    state: {
        loading: {
            status: false,
            duration: 750
        },

        mainMenu: {
            status: false
        },
    },
})

export { Vue, axios, store }
